export default {
  busNotificationTemplateList: [],
  busNotificationTemplateInfo: null,
  categoriesList: [],
  categoryInfo: null,
  currentPage: null
}
